import React, { useEffect, useState } from "react";
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useMsal } from "@azure/msal-react";
import { getAccessToken, fetchData } from '../common/MSALHelper.js'
import ButtonSpinner from "./ButtonSpinner.js";
import { useNavigate } from "react-router-dom";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function ReportLauncher({ pdfUrl }) {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();

    // const [numPages, setNumPages] = useState(null);
    // const [pageNumber, setPageNumber] = useState(1);

    const [yearbuttons, setYearbuttons] = useState(null);

    // const onLoadSuccess = ({ numPages }) => {
    //     setNumPages(numPages);
    //     console.log(`PDF loaded successfully with ${numPages} pages`)

    //     handleTextReplace();
    //     console.log("Called handleTextReplace");
    // };

    useEffect(() => {
        //get years for the Receipts
        getAccessToken(instance, accounts).then(response => {
            fetchData(response, '/contribution_yearcount', res => {
                if (!res.ok)
                    throw new Error(`HTTP error! status: ${res.status}`);

                return res.json();
            }, data => {
                setYearbuttons(data);
            })
        })
    }, [instance, accounts])

    // const handleTextReplace = async () => {
    //     // Load the PDF document
    //     const pdfDocument = await pdfjs.getDocument(pdfUrl).promise;

    //     // Iterate over each page
    //     for (let pageNum = 1; pageNum <= numPages; pageNum++) {
    //         // Get the page text
    //         const page = await pdfDocument.getPage(pageNum);
    //         const pageText = await page.getTextContent();

    //         // Iterate over each text item on the page
    //         for (let i = 0; i < pageText.items.length; i++) {
    //             const textItem = pageText.items[i];
    //             console.log(textItem.str);

    //             const nameValue = "Lan Tran";
    //             // Check if the text matches the target
    //             if (textItem.str.includes(nameValue)) {
    //                 // Find the starting and ending indices of "Lan Tran"
    //                 const startIndex = textItem.str.indexOf(nameValue);
    //                 const endIndex = startIndex + nameValue.length;
                  
    //                 // Replace the text with the desired value
    //                 textItem.str = textItem.str.substring(0, startIndex) + "{name}" + textItem.str.substring(endIndex);
    //               }
    //         }
    //     }

    //     // Render the modified PDF
    //     // Note: This will render the entire PDF again, including all pages
    //     setPageNumber(1);
    // };

    // const download_file = () => {
    //     getAccessToken(instance, accounts).then((response) => {
    //         let accessToken = response;
    //         const ids = [10000];
    //         const idString = ids.join(',');
    //         fetchData(accessToken, `/download_receipt?ids=${idString}`, response => {
    //             if (!response.ok)
    //                 throw new Error(`HTTP error! status: ${response.status}`);

    //             return response.blob();
    //         }, data => {
    //             const blob_data = data;
    //             console.log(blob_data);

    //             // Create a downloadable link
    //             // Create a blob URL for the blob
    //             const blobUrl = URL.createObjectURL(blob_data);
    //             const link = document.createElement('a');
    //             link.href = blobUrl;
    //             link.download = 'tax_receipts.pdf'; // Set default filename if not provided

    //             // Trigger the download
    //             link.click();

    //             // Cleanup the temporary URL (optional)
    //             setTimeout(() => URL.revokeObjectURL(link.href), 1000); // Revoke after 1 second

    //             return blob_data;
    //         });

    //     });
    // }


    const YearButtons = () => {
        if (yearbuttons)
        {
            // console.log(yearbuttons);
            return yearbuttons.map(x => (
                <div key={`yearbutton_${x.Year}`} className="YearBlock">
                    <button onClick={() => navigate(`/ReportYearlyAll/${x.Year}`)}>View All Donations for {x.Year}</button>
                    <button onClick={() => navigate(`/ReportYearlyContribution/${x.Year}`)}>View Contributions for {x.Year}</button>
                    <label>Total {x.Count}</label>
                </div>
            ));
            // return <button onClick={download_file}>Placeholder</button>;
        }
        else
            return <></>;
    }

    return (
        <div>
            {/* <div className="pdf-viewport">
                <div className="pdf-container">
                    <Document file={pdfUrl} onLoadSuccess={onLoadSuccess}>
                        <Page pageNumber={pageNumber}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            width={900} />
                    </Document>
                </div>
            </div> */}
            {/* <button onClick={download_file}>Download File</button> */}
            <YearButtons />
        </div>
    );
}